import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import NavBar from "../components/layout/NavBar";
import OuterContainer from "../components/layout/OuterContainer";
import Loading from "../components/Loading";
import { API_CONSTANT_MAP } from "../utils/constants/endpoints";
import { request } from "../services/networking/request";

const LoadingContainer = styled(OuterContainer)`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingWrapper = styled.div`
  text-align: center;
  padding: 32px;
`;

const LoadingText = styled.p`
  margin: 16px 0 0 0;
  font-size: 14px;
  color: #64748b;
  font-weight: 400;
`;

function TrackEmailClick() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Parse URL parameters
    const urlParams = new URLSearchParams(location.search);
    const trackingToken = urlParams.get('t');
    const redirectUrl = urlParams.get('redirect');

    console.log('TrackEmailClick - URL parameters:', {
      fullUrl: location.search,
      trackingToken: trackingToken,
      redirectUrl: redirectUrl,
      decodedToken: trackingToken ? decodeURIComponent(trackingToken) : null,
      decodedRedirect: redirectUrl ? decodeURIComponent(redirectUrl) : null
    });

    // If no tracking token or redirect URL, go to tasks page
    if (!trackingToken || !redirectUrl) {
      console.log('TrackEmailClick - Missing parameters, redirecting to tasks');
      navigate('/tasks');
      return;
    }

    // Call the tracking endpoint
    const trackClick = async () => {
      try {
        // Make GET request to track the click by constructing URL with query params
        const trackingUrl = `${API_CONSTANT_MAP.track_click}?t=${encodeURIComponent(trackingToken)}&redirect=${encodeURIComponent(redirectUrl)}`;
        console.log('TrackEmailClick - Making tracking request to:', trackingUrl);
        console.log('TrackEmailClick - URL breakdown:', {
          baseUrl: API_CONSTANT_MAP.track_click,
          rawToken: trackingToken,
          encodedToken: encodeURIComponent(trackingToken),
          rawRedirect: redirectUrl,
          encodedRedirect: encodeURIComponent(redirectUrl)
        });
        
        const response = await request('GET', trackingUrl);
        console.log('TrackEmailClick - Tracking response:', response.data);
      } catch (error) {
        console.error('TrackEmailClick - Error tracking email click:', error);
      } finally {
        // Always redirect to the final destination
        // Extract just the path and params from the redirect URL
        try {
          const redirectUrlObj = new URL(redirectUrl);
          const redirectPath = redirectUrlObj.pathname + redirectUrlObj.search;
          console.log('TrackEmailClick - Redirecting to:', redirectPath);
          navigate(redirectPath);
        } catch (e) {
          console.log('TrackEmailClick - URL parsing failed, going to tasks');
          // If URL parsing fails, go to tasks page
          navigate('/tasks');
        }
      }
    };

    trackClick();
  }, [location, navigate]);

  return (
    <>
      <NavBar />
      <LoadingContainer>
        <LoadingWrapper>
          <Loading />
          <LoadingText>
            Redirecting you to your tasks...
          </LoadingText>
        </LoadingWrapper>
      </LoadingContainer>
    </>
  );
}

export default TrackEmailClick;